/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReleaseStatus } from './ReleaseStatus';
import {
    ReleaseStatusFromJSON,
    ReleaseStatusFromJSONTyped,
    ReleaseStatusToJSON,
    ReleaseStatusToJSONTyped,
} from './ReleaseStatus';

/**
 * Another Drop under the same parent. Computed at route time from parentDropId.
 * @export
 * @interface DropSiblingTitle
 */
export interface DropSiblingTitle {
    /**
     * 
     * @type {string}
     * @memberof DropSiblingTitle
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof DropSiblingTitle
     */
    title: string;
    /**
     * The sibling Drop's own header image — the card's background.
     * @type {string}
     * @memberof DropSiblingTitle
     */
    headerImageUrl?: string;
    /**
     * The sibling Drop's own profile image — the card's mark. The Drop's two image slots, the same pair every Drop has.
     * @type {string}
     * @memberof DropSiblingTitle
     */
    profileImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof DropSiblingTitle
     */
    releaseDate?: number;
    /**
     * 
     * @type {ReleaseStatus}
     * @memberof DropSiblingTitle
     */
    status?: ReleaseStatus;
}



/**
 * Check if a given object implements the DropSiblingTitle interface.
 */
export function instanceOfDropSiblingTitle(value: object): value is DropSiblingTitle {
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function DropSiblingTitleFromJSON(json: any): DropSiblingTitle {
    return DropSiblingTitleFromJSONTyped(json, false);
}

export function DropSiblingTitleFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropSiblingTitle {
    if (json == null) {
        return json;
    }
    return {
        
        'slug': json['slug'],
        'title': json['title'],
        'headerImageUrl': json['headerImageUrl'] == null ? undefined : json['headerImageUrl'],
        'profileImageUrl': json['profileImageUrl'] == null ? undefined : json['profileImageUrl'],
        'releaseDate': json['releaseDate'] == null ? undefined : json['releaseDate'],
        'status': json['status'] == null ? undefined : ReleaseStatusFromJSON(json['status']),
    };
}

export function DropSiblingTitleToJSON(json: any): DropSiblingTitle {
    return DropSiblingTitleToJSONTyped(json, false);
}

export function DropSiblingTitleToJSONTyped(value?: DropSiblingTitle | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'slug': value['slug'],
        'title': value['title'],
        'headerImageUrl': value['headerImageUrl'],
        'profileImageUrl': value['profileImageUrl'],
        'releaseDate': value['releaseDate'],
        'status': ReleaseStatusToJSON(value['status']),
    };
}

